import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { FlexColumn } from '@mopla/ui';
import { Checkbox } from '@mopla/ui/atoms/Checkbox/Checkbox';
import { FormFields } from '@mopla/ui/organisms/PersonalDetailsForm/FormFields';

import { ContentWrapper } from '../DTicketSubscription.styles';
import { IAnotherRecipientBlockProps } from '../types';

import { ContentBlock } from './ContentBlock';

export const SecondStep: FC = () => {
	const { t } = useTranslation(['dticket', 'validation']);

	return (
		<ContentBlock headerText={t('header.subscription_user')}>
			<FlexColumn className="spaceBetween" style={{ gap: 8 }}>
				<Typography variant="body2" color="neutral.80">
					{t('label.mandatory_fields')}
				</Typography>
				<FormFields
					showAddressToggle={false}
					dateOfBirthRequired
					withPaddings={false}
				/>
			</FlexColumn>
		</ContentBlock>
	);
};

export const AnotherRecipientBlock: FC<IAnotherRecipientBlockProps> = (
	props
) => {
	const { showInvoiceRecipientForm, toggleInvoiceForm } = props;
	const { t } = useTranslation(['dticket', 'validation']);

	return (
		<ContentWrapper>
			<Checkbox
				name="another-invoice-recipient"
				checked={showInvoiceRecipientForm}
				onChange={toggleInvoiceForm}
				label={t('label.another_invoice_recipient')}
			/>
			{showInvoiceRecipientForm && (
				<FlexColumn className="spaceBetween" style={{ gap: 8 }}>
					<Typography variant="body2" color="neutral.80">
						{t('label.mandatory_fields')}
					</Typography>
					<FormFields
						showCompanyField
						showDates={false}
						showAddressToggle={false}
						dateOfBirthRequired
						withPaddings={false}
					/>
				</FlexColumn>
			)}
		</ContentWrapper>
	);
};
